import React from "react";
import styled from "styled-components";
import {ResetButton} from "../../../styles/Button";
import Color from "../../../assets/Colors";

export default function FloatButton({action}) {
   return (
      <ContentStyled>
         <Buttostyled>Inscribirme</Buttostyled>
      </ContentStyled>
   );
}

const ContentStyled = styled.div`
   display: none;

   @media screen and (max-width: 500px) {
      display: block;
      position: fixed;
      right: 0;
      bottom: 0;
      width: 100%;
      padding: 0.5em;
      background-color: #eaeceb;
      z-index: 5;
   }
`;
const Buttostyled = styled(ResetButton)`
   padding: 0.7em;
   width: 100%;
   color: white;
   background-color: ${Color.primary};
   font-size: 1.3em;
   text-transform: uppercase;
   font-family: Montserrat;
`;
